import { render, staticRenderFns } from "./VideoCardTitle.vue?vue&type=template&id=3def2398&"
import script from "./VideoCardTitle.vue?vue&type=script&lang=ts&"
export * from "./VideoCardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports